import React, { Component } from "react"
import { withRouter, Link } from "react-router-dom"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
import { TableLayout } from "../../../components"
import { LoadModal } from "../../modais"
import { ToastContainer, ToastMessage } from "react-toastr"
import ReactPaginate from "react-paginate"
import { confirmAlert } from "react-confirm-alert"
class TableAditivos extends Component {
  constructor() {
    super()
    this.toastFactory = React.createFactory(ToastMessage.animation)
    this.delete = this.delete.bind(this)
    this.getFicha = this.getFicha.bind(this)
    this.toggleLoadModal = this.toggleLoadModal.bind(this)
    this.state = {
      showLoad: false
    }
  }

  addAlert(title, message) {
    this.container.error(title, message, {
      timeOut: 5000,
      extendedTimeOut: 3000
    })
  }
  delete(id) {
    confirmAlert({
      title: "Confirme a remoção",
      message: "Tem certeza que deseja deletar?",
      buttons: [
        {
          label: "Sim",
          onClick: () =>
            ApiHelper.deleteContrato(id, error => {
              if (error) {
                this.addAlert("", error.message)
              } else {
                this.props.onDelete()
              }
            })
        },
        {
          label: "Não"
        }
      ]
    })
  }
  toggleLoadModal() {
    this.setState({
      showLoad: !this.state.showLoad
    })
  }
  getFicha(id) {
    this.toggleLoadModal()
    ApiHelper.getFichaContrato(id, (ficha, error) => {
      this.toggleLoadModal()
      if (ficha) {
        var url = URL.createObjectURL(ficha)
        var tempLink = document.createElement("a")
        tempLink.href = url
        tempLink.setAttribute(
          "download",
          "Ficha Contrato Número:" + id + ".pdf"
        )
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
      } else {
        this.addAlert("", error.message)
      }
    })
  }
  render() {
    var tableHeaders = [
      "Número do aditivo",
      "Objeto",
      "Assinado em",
      "Final da vigência",
      "Ações"
    ]
    var buttons = [
      {
        title: "Criar aditivo",
        link: "/aditivos/create/" + this.props.match.params.id,
        icon: "control_point"
      },
      { title: "Aditivos deletados", link: "/aditivosTrash", icon: "delete" }
    ]
    return (
      <div>
        <ToastContainer
          ref={input => {
            this.container = input
          }}
          toastMessageFactory={this.toastFactory}
          className="toast-top-right"
          preventDuplicates={true}
        />
        <LoadModal onClose={this.toggleLoadModal} show={this.state.showLoad} />
        <TableLayout
          headerButtons={buttons}
          sizeClass={this.props.sizeClass}
          backgroundColor={this.props.backgroundColor}
          title={this.props.title}
          subtitle={this.props.subtitle}
          filter={this.props.filter}
          searchLabel="Pesquisar aditivo"
        >
          <table className="table table-hover">
            <thead className="text-warning">
              <tr>
                {tableHeaders.map((header, key) => {
                  return <th key={key}>{header}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {this.props.rows.map((row, key) => {
                return (
                  <tr key={key}>
                    <td className="col-md-2">{row.num_contrato}</td>
                    <td className="col-sm-7">{row.objeto}</td>
                    <td className="col-sm-2">
                      {Moment(row.data_assinado).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-2">
                      {Moment(row.final_vigencia.date).format("D/MM/Y")}
                    </td>
                    <td className="col-sm-1 td-actions text-right">
                      <Link
                        title="Editar aditivo"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"/aditivos/edit/" + row.id}
                      >
                        <i className="material-icons">edit</i>
                      </Link>
                      <Link
                        title="Digitalizações"
                        className="btn btn-primary btn-simple btn-xs"
                        to={"/digitalizados/" + row.id}
                      >
                        <i className="material-icons">insert_drive_file</i>
                      </Link>
                      <button
                        type="button"
                        rel="tooltip"
                        title="Remover aditivo"
                        onClick={() => this.delete(row.id)}
                        className="btn btn-danger btn-simple btn-xs"
                      >
                        <i className="material-icons">close</i>
                      </button>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
          <ReactPaginate
            previousLabel="Anterior"
            nextLabel="Próximo"
            breakLabel={<a href="">...</a>}
            breakClassName="break-me"
            pageCount={this.props.pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={30}
            onPageChange={this.props.handlePageClick}
            containerClassName="pagination"
            subContainerClassName="pages pagination"
            activeClassName="active"
          />
        </TableLayout>
      </div>
    )
  }
}
export default withRouter(TableAditivos)



// WEBPACK FOOTER //
// ./src/views/contratos/aditivos/TableAditivos.js